import { Component, DestroyRef, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterLinkFactory } from '../../../core/router/router-link-factory';
import { AuthService } from '../../../core/services/auth.service';
import { LaundryService } from '../../../core/services/laundry.service';
import { BaseResponse } from '../../../core/interfaces/base-response';
import { Laundry } from '../../../core/interfaces/laundry';
import {
  LANG,
  LAUNDRY,
  LAUNDRY_DELIVERY,
  LAUNDRY_MANAGER,
  LAUNDRY_STAFF,
  PERMISSIONS,
  TOKEN,
  USER_DATA,
} from '../../../core/utils/constant';
import { environment } from '../../../../environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoDirective } from '@jsverse/transloco';
import { IconsService, LoadingSpinnerComponent } from '@rieaya-core';
import { User } from '../../../core/interfaces/user';

@Component({
  selector: 'app-login',
  imports: [TranslocoDirective, LoadingSpinnerComponent],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  icons = inject(IconsService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private links = inject(RouterLinkFactory);
  private laundryService = inject(LaundryService);
  private destroyRef = inject(DestroyRef);
  private activatedRoute = inject(ActivatedRoute);

  userTypes!: any[];

  isLogin = signal<boolean>(false);
  loginLoading = signal<boolean>(false);
  loginError = signal<boolean>(false);
  roleLoading = signal<boolean>(false);
  selectedRoleIndex = signal<number | null>(null);

  LAUNDRY_MANAGER = LAUNDRY_MANAGER;

  LAUNDRY_STAFF = LAUNDRY_STAFF;

  LAUNDRY_DELIVERY = LAUNDRY_DELIVERY;

  userData!: User;

  private loginData!: any;

  constructor() {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token') || '';

    if (token) {
      localStorage.setItem(TOKEN, token);
      this.loginLoading.set(true);
      this.loginError.set(false);
      this.authService
        .login()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (res: any) => {
            this.loginLoading.set(false);
            this.loginData = res;
            localStorage.setItem(TOKEN, res.data.token);
            const lang = localStorage.getItem(LANG) || 'en';
            localStorage.setItem(LANG, lang);

            this.userData = res.data.userData;

            localStorage.setItem(
              USER_DATA,

              JSON.stringify(res.data.userData)
            );
            this.userTypes = res.data.rolesAndPermissions;
            this.isLogin.set(true);
          },
          error: () => {
            this.loginLoading.set(false);
            this.loginError.set(true);
            setTimeout(() => {
              window.location.href = environment.LoginSSOROP;
            }, 5000);
          },
        });
    }
  }

  selectUsertype(userType: any, index: number): void {
    if (this.roleLoading()) return;

    this.roleLoading.set(true);
    this.selectedRoleIndex.set(index);

    const userData = JSON.parse(localStorage.getItem(USER_DATA) ?? '');

    localStorage.setItem(
      USER_DATA,

      JSON.stringify({
        ...userData,
        role: userType.userType,
        onlyCollectionPoint:
          userType.laundry?.onlyCollectionPoint ?? false,
      })
    );

    localStorage.setItem(PERMISSIONS, JSON.stringify(userType.modules));
    this.getLaundryDetails(userType.laundry.id, userType.userType);
  }

  getLaundryDetails(id: string, role: string): void {
    this.laundryService
      .getLaundryById(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: BaseResponse<Laundry>) => {
          localStorage.setItem(LAUNDRY, JSON.stringify(response.data));

          if (role === LAUNDRY_MANAGER) {
            this.navigateAfterRoleSelection(this.links.homepage());
          } else if (role === LAUNDRY_STAFF || role === LAUNDRY_DELIVERY) {
            this.navigateAfterRoleSelection(this.links.orders());
          } else {
            this.clearRoleLoading();
          }
        },
        error: () => this.clearRoleLoading(),
      });
  }

  private navigateAfterRoleSelection(
    commands: Parameters<Router['navigate']>[0]
  ): void {
    void this.router
      .navigate(commands)
      .then((navigated) => {
        if (!navigated) {
          this.clearRoleLoading();
        }
      })
      .catch(() => this.clearRoleLoading());
  }

  private clearRoleLoading(): void {
    this.roleLoading.set(false);
    this.selectedRoleIndex.set(null);
  }
}
